export const ENV = { ENV: "stage", HOST_BACKEND: "https://api.stage.dareresponse.com" };